import React from 'react';
interface ProgressBarProps {
  progress: number;
  className?: string;
}
export function ProgressBar({
  progress,
  className = ''
}: ProgressBarProps) {
  return <div className={`w-full h-4 rounded-full backdrop-blur-xl bg-white/20 border border-white/30 overflow-hidden ${className}`} data-id="element-57">
      <div className="h-full bg-gradient-to-r from-purple-400 to-pink-400 rounded-full transition-all duration-500 ease-out shadow-lg" style={{
      width: `${Math.min(progress, 100)}%`
    }} data-id="element-58" />
    </div>;
}